import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentNotWorking from "@/pages/DepressionTreatmentNotWorking";
export const Route = createFileRoute("/depression-treatment-not-working")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "When Depression Treatment Isn't Working | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "What to do when antidepressants, therapy, or other depression treatments aren't working. Understand treatment-resistant depression and your options.",
        },
        {
          property: "og:title",
          content: "When Depression Treatment Isn't Working | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "What to do when antidepressants, therapy, or other depression treatments aren't working. Understand treatment-resistant depression and your options.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/depression-treatment-not-working",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-not-working",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentNotWorking />;
}
